import * as React from 'react';
import { Switch, Select } from '../../../components/ui';
import {useFormContext, Controller} from 'react-hook-form';

import {AccountSettingsContext} from '../../context/AccountSettingsContext';
import {SelectContainer} from './AccountContainer.style';

export function AccountRegisterComponent(): JSX.Element {
  const {account, updateAccount} = React.useContext(AccountSettingsContext);
  const {registerEnabled, requiresPlanOnSignup, registerStatus} = account;
  const {
    control
  } = useFormContext();

  const REGISTER_STATUSES = ['ativo', 'pendente', 'inativo', 'cancelado'];

  return (
    <>
      <div className="row">
        <div className="col s12">
          <h2>Novos Cadastros</h2>
        </div>
      </div>
      <div className="row">
        <div className="col s12">
          <label htmlFor="registerEnabled">
            Permitir cadastro de novos usuários?
          </label>
          <Controller
            name="registerEnabled"
            control={control}
            render={({field: {onChange, value}}) => (
              <Switch
                offLabel="Não"
                onLabel="Sim"
                id="registerEnabled"
                onChange={({target}) => {
                  const checked = !!target.checked;
                  onChange(checked);
                  updateAccount({registerEnabled: checked});
                }}
                checked={value ?? registerEnabled ?? false}
              />
            )}
          />
        </div>
      </div>
      {!!registerEnabled && (
        <>
          <div className="row">
            <div className="col s12">
              <h3>Defina os padrões de novos cadastros</h3>
            </div>
          </div>
          <div className="row">
            <SelectContainer>
              <Controller
                name="registerStatus"
                control={control}
                render={({field: {onChange, value}}) => (
                  <Select
                    id="registerStatus"
                    value={value || registerStatus}
                    onChange={(e) => {
                      onChange(e);
                      updateAccount({registerStatus: e.target.value});
                    }}
                    label="Qual o status de novos cadastros?">
                    {REGISTER_STATUSES.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </Select>
                )}
              />
            </SelectContainer>
            <div className="col s12">
              <label htmlFor="requiresPlanOnSignup">
                Exigir a escolha de um plano ao se cadastrar?
              </label>
              <Controller
                name="requiresPlanOnSignup"
                control={control}
                render={({field: {onChange, value}}) => (
                  <Switch
                    offLabel="Não"
                    onLabel="Sim"
                    id="requiresPlanOnSignup"
                    name="requiresPlanOnSignup"
                    onChange={({target}) => {
                      const checked = !!target.checked;
                      onChange(checked);
                      updateAccount({requiresPlanOnSignup: checked});
                    }}
                    checked={value ?? requiresPlanOnSignup ?? false}
                  />
                )}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
}
